<template>
  <div class="form-info-text">
    <span class="badge badge-pill badge-warning">Info</span>
    Vlastnost typu trigger / externí volání nemá žadnou možnost editace.
  </div>
</template>

<script>
export default {
    name: 'TriggerInput',
    props: {
        id: { required: true },
        value: { default: _ => {return { 'value': false }} },
    },
    computed: {
        valueModel: {
            get() {
                return this.value.value
            },
            set(value) {
                this.value.value = value
                this.$emit('change', this.value)
            },
        },
    },
}
</script>

<style>
</style>
